import { useCallback, useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
const COPIED_RESET_MS = 2000;

interface UseCopyToClipboardMessages {
  success: string;
  empty: string;
  error: string;
}

export const useCopyToClipboard = (messages: UseCopyToClipboardMessages) => {
  const [copied, setCopied] = useState(false);
  const resetTimeout = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => () => clearTimeout(resetTimeout.current), []);

  const copy = useCallback(
    async (value?: string) => {
      if (!value) {
        toast.error(messages.empty);
        return;
      }

      try {
        await navigator.clipboard.writeText(value);
        setCopied(true);
        toast.success(messages.success);

        clearTimeout(resetTimeout.current);
        resetTimeout.current = setTimeout(
          () => setCopied(false),
          COPIED_RESET_MS,
        );
      } catch (error) {
        toast.error(messages.error);
      }
    },
    [messages.empty, messages.success, messages.error],
  );

  return { copied, copy };
};

export default useCopyToClipboard;
